import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {TopActionBarComponent} from '~/app/components/top-action-bar/top-action-bar.component';
import {SideDrawerMenuComponent} from '~/app/components/side-drawer-menu/side-drawer-menu.component';
import {IonicModule} from '@ionic/angular';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {OfferCouponComponent} from '~/app/components/offer-coupon/offer-coupon.component';
import {OfferItemComponent} from '~/app/components/offer-item/offer-item.component';
import {OfferListComponent} from '~/app/components/offer-list/offer-list.component';
import {ShortDomainPipe} from '~/app/components/url-format/short-domain.pipe';
import {PhoneFormatPipe} from '~/app/components/phone-format/phone-format.pipe';
import {HomeComponent} from '~/app/components/home/home.component';
import {MapComponent} from '~/app/components/map/map.component';
import {AchievementsComponent} from '~/app/components/achievements/achievements.component';
import {SearchComponent} from '~/app/components/search/search.component';
import {AccountComponent} from '~/app/components/account/account.component';
import {AccountAboutComponent} from '~/app/components/account-menu/About/accountAbout.component';
import {
  AccountContactMerchantComponent
} from '~/app/components/account-menu/Merchants/accountContactMerchant.component';
import {AccountContactProblemComponent} from '~/app/components/account-menu/Report/accountContactProblem.component';
import {AccountFAQComponent} from '~/app/components/account-menu/FAQ/accountFAQ.component';
import {AccountContactSponsorComponent} from '~/app/components/account-menu/Sponsors/accountContactSponsor.component';
import {AccountMessageComponent} from '~/app/components/account-menu/Message/accountMessage.component';
import {AccountNotificationComponent} from '~/app/components/account-menu/Notification/accountNotification.component';
import {AccountPoliciesComponent} from '~/app/components/account-menu/Policies/accountPolicies.component';
import {SmallOfferViewComponent} from '~/app/components/small-offer-view/small-offer-view.component';
import {OfferListHorizontalComponent} from '~/app/components/offer-list-horizontal/offer-list-horizontal.component';
import {CategoriesListHorizontalComponent} from '~/app/components/categories-list-horizontal/categories-list-horizontal.component';
import {MediumOfferViewComponent} from '~/app/components/medium-offer-view/medium-offer-view.component';
import {LargeOfferViewComponent} from '~/app/components/large-offer-view/large-offer-view.component';
import {RedeemDialogComponent} from '~/app/pages/offer/redeemDialog.component';
import {CongratulationsDialogComponent} from '~/app/pages/offer/congratulationsDialog.component';
import {ContactUsComponent} from '~/app/components/contact-us/contact-us.component';
import {FormsModule} from '@angular/forms';
import {DisableComponent} from '~/app/components/disable/disable.component';
import {
  LocationServicesPopupComponent
} from "~/app/components/location-services-popup/location-services-popup.component";

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    CoreModule,
    IonicModule,
    FormsModule,
  ],
    declarations: [
        OfferListComponent,
        // OfferMapComponent,
        OfferCouponComponent,
        // OfferCouponOpenComponent,
        OfferItemComponent,
        HomeComponent,
        MapComponent,
        SearchComponent,
        AchievementsComponent,
        AccountComponent,
        // SponsorLogoHeaderComponent,
        // OfferRedeemComponent,
        // OfferPurchaseMoreComponent,
        // GamificationStatusTicketsComponent,
        // GamificationStatusDailyComponent,
        // GamificationTicketsMenuComponent,
        // LocalizedFormattedLabelComponent,
        // OfferExperienceComponent,
        // SignUpReferralMenuComponent,
        // BottomNavigationMenuComponent,
        SideDrawerMenuComponent,
        // SearchDrawerMenuComponent,
        PhoneFormatPipe,
        TopActionBarComponent,
        ShortDomainPipe,
        AccountAboutComponent,
        AccountFAQComponent,
        AccountPoliciesComponent,
        AccountContactMerchantComponent,
        AccountMessageComponent,
        AccountNotificationComponent,
        AccountContactSponsorComponent,
        AccountContactProblemComponent,
        OfferListHorizontalComponent,
        LargeOfferViewComponent,
        MediumOfferViewComponent,
        SmallOfferViewComponent,
        CategoriesListHorizontalComponent,
        RedeemDialogComponent,
        CongratulationsDialogComponent,
      ContactUsComponent,
      DisableComponent,
      LocationServicesPopupComponent
    ],
    exports: [
        OfferListComponent,
        // OfferMapComponent,
        OfferCouponComponent,
        // OfferCouponOpenComponent,
        OfferItemComponent,
        HomeComponent,
        MapComponent,
        SearchComponent,
        AchievementsComponent,
        AccountComponent,
        // OfferExperienceComponent,
        // SignUpReferralMenuComponent,
        // SponsorLogoHeaderComponent,
        // OfferRedeemComponent,
        // OfferPurchaseMoreComponent,
        // GamificationStatusTicketsComponent,
        // GamificationStatusDailyComponent,
        // GamificationTicketsMenuComponent,
        // LocalizedFormattedLabelComponent,
        // BottomNavigationMenuComponent,
        SideDrawerMenuComponent,
        // SearchDrawerMenuComponent,
        PhoneFormatPipe,
        TopActionBarComponent,
        ShortDomainPipe,
        AccountAboutComponent,
        AccountFAQComponent,
        AccountPoliciesComponent,
        AccountContactMerchantComponent,
        AccountMessageComponent,
        AccountNotificationComponent,
        AccountContactSponsorComponent,
        AccountContactProblemComponent,
        SmallOfferViewComponent,
        MediumOfferViewComponent,
        LargeOfferViewComponent,
        OfferListHorizontalComponent,
        CategoriesListHorizontalComponent,
        RedeemDialogComponent,
        CongratulationsDialogComponent,
      ContactUsComponent,
      DisableComponent,
      LocationServicesPopupComponent
    ],
    entryComponents: [
        // PagerV3Component,
        // SlideComponent,
        // OfferItemComponent
    ],
    schemas: [
        NO_ERRORS_SCHEMA
    ]
})
export class ComponentsModule {
}
